module.exports = __webpack_public_path__ + "static/media/wave-6.3cca6bd8.svg";